import { FormFields } from "../../../../models/newSupportCall";
import SupportCallOccurrenceFields from "../SupportCallOccurrenceFields";

export interface ICancellationFormData {
    formData: FormFields;
    errors: Partial<Record<keyof FormFields, string>>;
    updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
    name: string;
    fetchVehicle: (chassis: string) => Promise<void>;
    loadingLicensePlate?: boolean;
    occurrenceId?: string;
}

const fieldColumnClassName = 'form-group form-group-lg flex-1-1';

const CancellationForm = ({ formData, errors, updateField, name, fetchVehicle, loadingLicensePlate, occurrenceId }: ICancellationFormData) => {
    return (
        <>
            <SupportCallOccurrenceFields
                formData={formData}
                errors={errors}
                updateField={updateField}
                name={name}
                fetchVehicle={fetchVehicle}
                subject="CONTRACT_CANCELLATION"
                loadingLicensePlate={loadingLicensePlate}
                occurrenceId={occurrenceId}
            />
            <div className='margin-top-20'>
                <p className='text-size-16 text-bold'>2. Dados adicionais</p>
                <div className='padding-15 margin-top-20 rounded border'>
                    <div className='display-flex gap-20'>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>Número do contrato *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder="Obrigatório"
                                value={formData.contractNumber}
                                onChange={event => updateField('contractNumber', event.target.value)}
                            />
                            {errors.contractNumber ? <span className='text-size-12 text-color-danger'>{errors.contractNumber}</span> : null}
                        </div>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>Quantidade de veículos *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder="Obrigatório"
                                value={formData.vehicleQtd}
                                onChange={event => updateField('vehicleQtd', event.target.value)}
                            />
                            {errors.vehicleQtd ? <span className='text-size-12 text-color-danger'>{errors.vehicleQtd}</span> : null}
                        </div>
                        <div className={fieldColumnClassName}>
                            <label className='text-size-14 text-color-darker margin-bottom-10'>Motivo do cancelamento *</label>
                            <input
                                type='text'
                                className='form-control'
                                placeholder="Obrigatório"
                                value={formData.cancelReason}
                                onChange={event => updateField('cancelReason', event.target.value)}
                            />
                            {errors.cancelReason ? <span className='text-size-12 text-color-danger'>{errors.cancelReason}</span> : null}
                        </div>
                    </div>
                    <div className="margin-top-20">
                        <p className='text-size-14 text-color-darker'>Descrever a solicitação *</p>
                        <textarea
                            className="form-control margin-top-10"
                            rows={3}
                            placeholder="Obrigatório"
                            value={formData.cancelComment}
                            onChange={event => updateField('cancelComment', event.target.value)}
                        />
                        {errors.cancelComment ? <span className='text-size-12 text-color-danger'>{errors.cancelComment}</span> : null}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CancellationForm;
